const text = (value) => String(value ?? '').trim();

export const shipToRecords = (value) => Array.isArray(value) ? value : value && typeof value === 'object' ? [value] : [];
export const isInternationalShip = (value) => value === true || value === 1 || ['true', 'yes', '1'].includes(text(value).toLowerCase());
export const formatShipToLocation = (record) => [record?.ShipToCity, record?.ShipToState,
  isInternationalShip(record?.InternationalShip) ? record?.ShipToCountry : '']
  .map(text).filter(Boolean).join(', ');

export const getScheduleLocation = (job, soldToShipToByProject = {}) => {
  const projectId = job?.ID ?? job?.ProjectID ?? job?.ProjectId;
  const cached = soldToShipToByProject[projectId]?.data;
  const record = [...shipToRecords(job?.SoldToShipTo), ...shipToRecords(job?.soldToShipTo), ...shipToRecords(cached)]
    .find((address) => text(address?.ShipToCity) || text(address?.ShipToState));
  const shipTo = record ? formatShipToLocation(record) : '';
  const value = shipTo || text(job?.JobLocation);
  return { value, fromShipTo: Boolean(shipTo), estimated: !shipTo && Boolean(value) };
};
